import { useState } from "react";
import type { Character } from "@/types";

export default function CharacterCard({ character, index }: { character: Character; index: number }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 animate-fade-up sm:flex-row"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="relative h-52 w-full shrink-0 overflow-hidden bg-background-200 sm:h-auto sm:w-40">
        <img
          src={character.image}
          alt={`${character.name}角色形象`}
          title={`${character.name}（${character.actor} 饰）角色分析`}
          className="h-full w-full object-cover object-top"
        />
        <span className="absolute left-2 top-2 rounded bg-primary-900/80 px-2 py-0.5 text-[11px] text-background-50 backdrop-blur">
          {character.role}
        </span>
      </div>
      <div className="flex min-w-0 flex-1 flex-col p-4">
        <div className="flex flex-wrap items-baseline gap-x-2">
          <h3 className="font-heading text-lg font-bold text-foreground-950">{character.name}</h3>
          <span className="text-xs text-foreground-500">由 {character.actor} 饰演</span>
        </div>
        <p
          className={`mt-2 text-sm leading-relaxed text-foreground-600 ${
            expanded ? "" : "line-clamp-3"
          }`}
        >
          {character.description}
        </p>
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="mt-3 flex w-fit items-center gap-1 text-xs font-medium text-primary-700 hover:text-primary-500 cursor-pointer whitespace-nowrap"
        >
          {expanded ? "收起角色详情" : "展开角色详情"}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
          </span>
        </button>
      </div>
    </div>
  );
}